module.exports = __webpack_public_path__ + "img/amrei_11_done_2.aef54f50.jpeg";